import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ROUTE_HOME } from '../app.constants';
import { FeatureFlag } from '../model/feature-flag.model';
import { BeraterFeatureFlagService } from '../service/feature-flag/berater-feature-flag.service';

/**
 * Configurable guard to check if a feature flag is enabled.
 * Uses the app-specific feature-flag service and redirects to not-found if disabled.
 * Usage:
 * ```typescript
 * export const appRoutes: Route[] = [
 *   {
 *     path: '',
 *     component: FrontpageComponent,
 *     canActivate: [featureFlagGuard(FeatureFlags.SPOTTARIF)],
 *     children: [],
 *   },
 * ```
 */
export function featureFlagGuard(flag: FeatureFlag): CanActivateFn {
  return async () => {
    const router = inject(Router);
    const featureFlagService = inject(BeraterFeatureFlagService);
    const enabled = await firstValueFrom(featureFlagService.getFeatureFlagStatus(flag));
    return enabled ? true : router.parseUrl(`/${ROUTE_HOME}`);
  };
}
